// 仅在按钮入口调用，校验通过后才打开操作弹窗或页面。
export default {
    methods: {
        checkDepositBefore(action) {
            this.request({
                url: '/sys_saas/deposit/check',
                loading: true,
                success: () => action()
            });
        }
    }
};
